module.exports = __webpack_public_path__ + "img/forever-bg.99663982.svg";